import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Text } from '../typography';
import {
  ButtonContainer,
  Container,
  Item,
  ItemContainer,
  ItemContent,
  LogoContainer,
} from './PropertyInsurance.style.pn';

interface PropertyUpgradeProps {
  pathId: string;
  box?: boolean;
  isRent: boolean;
}

const PropertyUpgrade: React.FC<PropertyUpgradeProps> = ({ pathId, box, isRent }) => {
  const theme = useTheme();
  const Slot = box ? ButtonContainer : LogoContainer;
  return (
    <Container $box={box} data-testid="property-upgrade">
      <Item>
        <ItemContainer colour={box ? theme.background : '#fcdbe2'} box={box}>
          <div>
            <Text fontSize={20} fontWeight="bold" mb={8}>
              Is this your property?
            </Text>
            <ItemContent data-testid="upgrade-text">
              {!box && <FontAwesomeIcon icon={faArrowRight} />}
              <Text maxWidth={!box ? 180 : undefined} fontSize={17}>
                Attract more {isRent ? 'tenants' : 'buyers'} by upgrading your listing.
              </Text>
            </ItemContent>
          </div>
          <Slot mw={box ? 400 : 180} justify={!box ? 'flex-end' : undefined}>
            <Link href={`/promote/premier?propertyId=${pathId}`} prefetch={false}>
              <Button>Upgrade Your Listing</Button>
            </Link>
          </Slot>
        </ItemContainer>
      </Item>
    </Container>
  );
};

export default PropertyUpgrade;
